export default __webpack_public_path__ + "static/media/img5.c842efb5.PNG";